export default __webpack_public_path__ + "static/media/Kesi.ba95a46e.jpeg";